import React, { Component } from 'react'
import { DatePicker, List, Modal, Toast } from 'antd-mobile'
import F2 from '@antv/f2/lib/index'
// import df from 'dateformat'
import { ROOT_PATH } from '../../config'
import send from '../../utils/send'
import df from 'dateformat'
import EmptyReport from '../../components/EmptyReport'
// import axios from 'axios';
// import {FARM_ORG, ORG_CODE, TOKEN} from '../../cache';
// import send from '../../utils/send'
// import qs from 'qs'
import Table from '../../components/Table';
// import LiveStockDetail from "./liveStockDetails";
import Gesture from '@antv/f2/lib/plugin/gesture'

F2.Chart.plugins.register(Gesture);
let Util = F2.Util;
const today = new Date();
let dataReady = false;
let TYPES = {
  'F': '分娩',
  'M': '配种',
  'A': '返情/空怀',
  'G': '后备种猪',
  'TIN': '转入',
  'V': '选种',
  'W': '断奶',
  'D': '死亡',
  'CH': '转移',
  'C': '淘汰'
};
let clientWidth = document.documentElement.clientWidth;
var legendItems = [
  {
    name: '母猪数目',
    marker: 'square',
    fill: '#108EE9',
    checked: true
  },
  {
    name: '实际胎次占比',
    marker: function marker(x, y, r, ctx) {
      ctx.lineWidth = 2;
      ctx.strokeStyle = ctx.fillStyle;
      ctx.moveTo(x - r - 3 - 3, y);
      ctx.lineTo(x + r + 3 + 3, y);
      ctx.stroke();
      ctx.fillStyle = '#fff';
      ctx.arc(x, y, r, 0, Math.PI * 2, false);
      ctx.fill();
      ctx.stroke()
    },
    fill: '#27D3A6',
    checked: true
  },
  {
    name: '标准',
    marker: function marker(x, y, r, ctx) {
      ctx.lineWidth = 2;
      ctx.strokeStyle = ctx.fillStyle;
      ctx.moveTo(x - r - 3 - 3, y);
      ctx.lineTo(x + r + 3 + 3, y);
      ctx.stroke();
      ctx.fillStyle = '#fff';
      ctx.arc(x, y, r, 0, Math.PI * 2, false);
      ctx.fill();
      ctx.stroke()
    },
    fill: '#FE5578',
    checked: true
  }
];

class ParityIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShow: false,
      modalHeader: '',
      modalContent: null,
      date: today,
      data2: [], //实际猪群饼图
      data1: [], // 母猪胎龄结构
      xNames: [],
      parity: {
        G: 'G',
        P0: '0胎',
        P1: '1胎',
        P2: '2胎',
        P3: '3胎',
        P4: '4胎',
        P5: '5胎',
        P6: '6胎',
        P7: '7胎',
        P8: '8胎',
        P9: '9胎',
        P10: '10胎',
        P11: '11胎',
        P12: '12胎',
        P13: '13胎',
        P999: '14胎+'
      },
      stockQty: [], // 实际库存
      percent: [] // 占比
    };
    this.modal = {
      columns: [
        {
          id: 'col1',
          title: '母猪耳号', //表头信息
          fixed: true, //是否为固定表头
          width: 150, //设置固定宽度
          align: 'left' //文本对齐方式 left center right
        },
        {
          id: 'col2',
          title: '胎次',
          width: 60,
          align: 'left'
        },
        {
          id: 'col3',
          width: 85,
          title: '当前状态',
          align: 'left'
        },
        {
          id: 'col4',
          width: 120,
          title: '当前状态日期',
          align: 'right'
        }
      ],
      data: []
    }
  }
  showSwinesInfo = async (parity) => {
 /*   let parity = p.split('胎')[0];
    if (parity > 13) {
      parity = '999'
    }*/
    let res = await send('/api/forward/ifarm/paritySwineInfo', {
      method: 'post',
      data: {
        transactionDate: df(this.state.date, 'yyyy-mm-dd'),
        parity
      }
    });
    // todo 当返回数据后，使用res.data取出我要的数据。
    this.modal.data = res.data.map(o => {
      let swineTrack = o.swineTrack || '';
      let current_parity = o.parity || parity;
      let activityType = o.activityType || '';
      let activityDate = o.activityDate?df(o.activityDate, 'yyyy-mm-dd'): '';
      return {
        col1: swineTrack,
        col2: current_parity,
        col3: TYPES[activityType] || activityType,
        col4: activityDate
      }
    });
    this.setState({
      modalShow: true
    })
  };
  getReport01 = () => {
    const _self = this;
    const { data1, parity } = this.state;
    let data = [];

   /***********************************************************************
     * 由于antv F2 cat类型在部分显示的数据，部分安卓机型，会出现line图，线会出现连接错乱错误
     * 紧致对应方案，强制将X轴的类型改为timeCat，后期需要通过antv源码去排查错误，将X轴标识更正
     * 为使用xName字段，cat类型
     ***********************************************************************/
    const date = new Date();
    const tempMap = {};
    const vals = [];
    data1.forEach(item => {
      date.setDate(date.getDate() + 1);
      let strDate = df(date, 'yyyy-mm-dd');
      tempMap[strDate] = item.xName;
      vals.push(strDate);
      data.push({
        strDate: strDate,
        xName: item.xName,
        type: '实际胎龄占比',
        value: item.actual,
        qty: item.qty
      });
      data.push({
        strDate: strDate,
        xName: item.xName,
        type: '标准',
        value: item.standard
      })
    });

    let chart = this.chart1;
    if (chart) {
      chart.clear()
    } else {
      chart = new F2.Chart({
        id: 'myChart1',
        pixelRatio: window.devicePixelRatio,
        padding: ['auto', 'auto', 'auto', 'auto'],
        plugins: [
          require('@antv/f2/lib/plugin/scroll-bar'),
          require('@antv/f2/lib/interaction/pan')
        ]
      })
    }
    this.chart1 = chart;
    chart.source(data, {
      strDate: {
        type: 'timeCat',
        tickCount: 7,
        values: vals.slice(0, 7),
        formatter: function(val) {
          let key = df(new Date(val), 'yyyy-mm-dd');
          return parity[tempMap[key]]
        }
      },
      qty: {
        line: {
          stroke: '#EEE'
        },
        tickCount: 5,
        alias: '母猪数目'
      },
      value: {
        tickCount: 5
      }
    });
    chart.axis('value', {
      line: {
        stroke: '#EEE'
      },
      grid: null,
      label: text => {
        return { text: text + '%' }
      }
    });
    chart.axis('qty', {
      line: {
        stroke: '#EEE'
      },
      label: text => {
        return { text: text }
      }
    });
    // chart.axis('xName', {
    //   nice: false,
    //   line: {
    //     top: true,
    //     stroke: '#EEE'
    //   },
    //   label: text => {
    //     return {
    //       text: parity[text],
    //       textAlign: 'center',
    //       textBaseline: 'top'
    //     }
    //   }
    // })
    // 自定义图例内容以及交互行为
    chart.legend({
      custom: true,
      items: legendItems,
      position: 'top',
      align: 'center',
      marker: {
        radius: 5
      },
      titleStyle: {
        fontSize: 14
      },
      valueStyle: {
        fontSize: 14
      }
    });

    chart.tooltip({
      onShow: function(ev) {
        ev.tooltipMarkerCfg.type = 'rect';
      }
    });
    chart
      .interval()
      .position('strDate*qty')
      .color('#108EE9')
      .size(20);

    chart
      .line({ connectNulls: false })
      .position('strDate*value')
      .color('type', function(item) {
        if (item === '实际胎龄占比') {
          return '#1CD1A1'
        } else {
          return '#FE5578'
        }
      })
      .shape('smooth');
    chart
      .point({
        connectNulls: false
      })
      .position('strDate*value')
      .color('type', function(item) {
        if (item === '实际胎龄占比') {
          return '#1CD1A1'
        } else {
          return '#FE5578'
        }
      })
      .size(3)
      .style({
        fill: '#fff',
        lineWidth: 1
      });

    data1.forEach(item => {
      // 柱状图
      chart.guide().text({
        position: [item.xName, item.qty],
        content: item.qty,
        offsetX: 0,
        offsetY: -10,
        limitInPlot: true
      })
    });
    // 定义进度条
    chart.scrollBar({
      mode: 'x',
      xStyle: {
        offsetY: -5
      }
    });
    chart.render();

    chart.interaction('pan', {
      speed: 1,
      mode: 'x'
    });
    chart.pluginGesture({
      gesture: {
        tap: (data, ev) => {
          const point = Util.getRelativePosition(ev.center, chart.get('canvas'));
          let plot = chart.get('plotRange');
          const { x, y } = point;
          const { tl, tr, br } = plot;
          if (x >= tl.x && x <= tr.x && y >= tl.y && y <= br.y) {
            console.log(data[0]._origin.xName);
            let parity = data[0]._origin.xName;
            if(parity !== 'G')parity = parity.split('P')[1];
            console.log(parity);
            _self.showSwinesInfo(parity)
            /*  this.setState({
                modalShow: true,
                modalContent: <LiveStockDetail data={locationId} />
              })*/
          }
        }
      }
    })



  };
  getReport02 = () => {
    const { data2 } = this.state;
    let chart = this.chart2;
    if (chart) {
      chart.clear()
    } else {
      chart = new F2.Chart({
        id: 'myChart2',
        plugins: require('@antv/f2/lib/plugin/pie-label'),
        pixelRatio: window.devicePixelRatio
      })
    }
    this.chart2 = chart;

    chart.source(data2);
    chart.coord('polar', {
      transposed: true,
      // innerRadius: 0.4,    是否是空心圆
      radius: 0.6
    });
    chart.axis(false);
    chart.legend({
      position: 'top',
      align: 'center',
      itemWidth: 60,
      marker: {
        radius: 5
      },
      valueStyle: {
        fontSize: 14
      }
    });
    chart.tooltip(false);
    chart.guide().html({
      position: ['50%', '50%'],
      html:
        '<div style="width: 100px;height: 20px;text-align: center;line-height: 20px;" id="textContent"></div>'
    });
    // 配置文本饼图
    chart.pieLabel({
      lineHeight: 45,
      sidePadding: 20,
      label1: function label2(data) {
        return {
          fill: '#000000',
          text: data.ratio + '% (' + data.amount + '头)',
          fontWeight: 500,
          fontSize: 10
        }
      }
    });
    chart
      .interval()
      .position('const*ratio')
      .color('memo', ['#1890FF', '#F46290', '#31C0B0', '#F3E300'])
      .adjust('stack');
    chart.render()

    /*    // 绘制内阴影
    var frontPlot = chart.get('frontPlot');
    var coord = chart.get('coord'); // 获取坐标系对象
    frontPlot.addShape('sector', {
      attrs: {
        x: coord.center.x,
        y: coord.center.y,
        r: coord.circleRadius * coord.innerRadius * 1.2, // 全半径
        r0: coord.circleRadius * coord.innerRadius,
        fill: '#000',
        opacity: 0.15
      }
    });
    chart.get('canvas').draw();*/
  };
  // 母猪胎龄结构对比 - 最佳猪群
  getReport03 = () => {
    const { data3 } = this.state;
    let chart = this.chart3;
    if (chart) {
      chart.clear()
    } else {
      chart = new F2.Chart({
        id: 'myChart3',
        plugins: require('@antv/f2/lib/plugin/pie-label'),
        pixelRatio: window.devicePixelRatio
      })
    }
    this.chart3 = chart;

    chart.source(data3);
    chart.coord('polar', {
      transposed: true,
      // innerRadius: 0.4,
      radius: 0.75
    });
    chart.axis(false);
    chart.legend({
      position: 'top',
      align: 'center',
      itemWidth: 60,
      marker: {
        radius: 5
      },
      valueStyle: {
        fontSize: 14
      }
    });
    chart.tooltip(false);
    chart.guide().html({
      position: ['50%', '50%'],
      html:
        '<div style="width: 100px;height: 20px;text-align: center;line-height: 20px;" id="textContent"></div>'
    });
    // 配置文本饼图
    chart.pieLabel({
      lineHeight: 45,
      sidePadding: 20,
      label1: function label2(data) {
        return {
          fill: '#000000',
          text: data.ratio + '% (' + data.amount + '头)',
          fontWeight: 500,
          fontSize: 10
        }
      }
    });
    chart
      .interval()
      .position('const*ratio')
      .color('memo', ['#1890FF', '#F46290', '#31C0B0', '#F3E300'])
      .adjust('stack');
    chart.render()

    /* // 绘制内阴影
    var frontPlot = chart.get('frontPlot');
    var coord = chart.get('coord'); // 获取坐标系对象
    frontPlot.addShape('sector', {
      attrs: {
        x: coord.center.x,
        y: coord.center.y,
        r: coord.circleRadius * coord.innerRadius * 1.2, // 全半径
        r0: coord.circleRadius * coord.innerRadius,
        fill: '#000',
        opacity: 0.15
      }
    });
    chart.get('canvas').draw();*/
  };
  // 母猪胎龄结构头数
  getData1 = date => {
    send(`${ROOT_PATH}/api/forward/ifarm/sowage-total-pig`, {
      method: 'POST',
      data: {
        startDate: date,
        endDate: date,
        dateToday: date,
        gdType: ['D000401'],
        gdCode: ['1001'],
        command: 'getCommand1',
        datasFlag: '2'
      }
    })
      .then(res => {
        let data = res.data[0] || {};
        this.setState({ stockQty: data });
        if (dataReady) {
          this.getData()
        }
        dataReady = true
      })
      .catch(execption => {
        console.log(execption)
      })
  };
  getData2 = date => {
    send(`${ROOT_PATH}/api/forward/ifarm/parityCompareGraph`, {
      method: 'POST',
      data: {
        startDate: date,
        endDate: date,
        dateToday: date,
        gdType: ['D000401'],
        gdCode: ['1001'],
        command: 'getCommand1',
        startsWith: '2'
      }
    })
      .then(res => {
        let data = res.data;
        this.setState({ percent: data }, () => {
          this.getData()
        })
      })
      .catch(execption => {
        return execption
      })
  };
  getData = () => {
    Toast.hide();
    const { percent, parity, data1 } = this.state;
    let stand = {};
    let act = {};
    percent.forEach(item => {
      item.gdCode === '1001' && (act = item.datas[0]);
      item.gdCode === '1002.02' && (stand = item.datas[0])
    });
    let sum = 0; // 母猪实际头数。如果为0 ，则表示此时没数据。
    Object.keys(parity).forEach(item => {
      sum = (act[item] || 0) + sum
    });
    dataReady = sum > 0;
    Object.keys(parity).forEach((item, i) => {
      // 当线的值为 null 不要连接。
      let standard = stand[item];
      let actual = sum > 0 ? ((act[item] / sum) * 100).toFixed(2) * 1 : 0;
      /*      standard = standard === 0 ? null : standard;
      actual = actual === 0 ? null : actual;*/
      data1[i] = {};
      // data1[i].xName = i === 0 ? 'G' : i + '胎'
      data1[i].xName = item;
      data1[i].parity = item;
      data1[i].qty = act[item];
      data1[i].standard = standard;
      data1[i].actual = actual
    });
    this.setState({
      data1,
      data2: [
        {
          memo: '0-1胎',
          amount: act['G'] + act['P0'] + act['P1'],
          ratio:
            sum > 0
              ? (((act['G'] + act['P0'] + act['P1']) / sum) * 100).toFixed(2) *
                1
              : 0,
          const: 'type'
        },
        {
          memo: '2-5胎',
          amount: act['P2'] + act['P3'] + act['P4'] + act['P5'],
          ratio:
            sum > 0
              ? (
                  ((act['P2'] + act['P3'] + act['P4'] + act['P5']) / sum) *
                  100
                ).toFixed(2) * 1
              : 0,
          const: 'type'
        },
        {
          memo: '6-9胎',
          amount: act['P6'] + act['P7'] + act['P8'] + act['P9'],
          ratio:
            sum > 0
              ? (
                  ((act['P6'] + act['P7'] + act['P8'] + act['P9']) / sum) *
                  100
                ).toFixed(2) * 1
              : 0,
          const: 'type'
        },
        {
          memo: '9胎以上',
          amount:
            act['P10'] + act['P11'] + act['P12'] + act['P13'] + act['P999'],
          ratio:
            sum > 0
              ? (
                  ((act['P10'] +
                    act['P11'] +
                    act['P12'] +
                    act['P13'] +
                    act['P999']) /
                    sum) *
                  100
                ).toFixed(2) * 1
              : 0,
          const: 'type'
        }
      ],
      data3: [
        {
          memo: '0-1胎',
          amount:
            sum > 0
              ? Math.round(
                  ((stand['G'] + stand['P0'] + stand['P1']) / 100) * sum
                )
              : 0,
          ratio: stand['G'] + stand['P0'] + stand['P1'],
          const: 'type'
        },
        {
          memo: '2-5胎',
          amount:
            sum > 0
              ? Math.round(
                  ((stand['P2'] + stand['P3'] + stand['P4'] + stand['P5']) /
                    100) *
                    sum
                )
              : 0,
          ratio: stand['P2'] + stand['P3'] + stand['P4'] + stand['P5'],
          const: 'type'
        },
        {
          memo: '6-9胎',
          amount:
            sum > 0
              ? Math.round(
                  ((stand['P6'] + stand['P7'] + stand['P8'] + stand['P9']) /
                    100) *
                    sum
                )
              : 0,
          ratio: stand['P6'] + stand['P7'] + stand['P8'] + stand['P9'],
          const: 'type'
        },
        {
          memo: '9胎以上',
          amount:
            sum > 0
              ? Math.round(
                  ((stand['P10'] +
                    stand['P11'] +
                    stand['P12'] +
                    stand['P13'] +
                    stand['P999']) /
                    100) *
                    sum
                )
              : 0,
          ratio:
            stand['P10'] +
            stand['P11'] +
            stand['P12'] +
            stand['P13'] +
            stand['P999'],
          const: 'type'
        }
      ]
    }, () => {
      this.getReport01();
      this.getReport02();
      this.getReport03()
    })

  };
  doSearch = date => {
    Toast.loading('加载中', 0);
    var d = df(date, 'yyyy-mm-dd');
    // this.getData1(d)
    this.getData2(d)
  };
  componentDidMount() {
    window._czc.push(['_trackEvent', '进入母猪胎龄结构页面']);
    const { date } = this.state;
    this.doSearch(date)
  }
  componentWillUnmount() {
    Toast.hide();
    this.setState(() => {

    })
  }
  render() {
    return (
      <React.Fragment>
        {/*<NavBar>母猪胎龄结构</NavBar>*/}
        <DatePicker
            mode="date"
            onChange={date => {
            this.setState({ date });
            dataReady = false;
            this.doSearch(date)
          }}
            value={this.state.date}
        >
          <List.Item arrow="horizontal">选择日期</List.Item>
        </DatePicker>
        <List renderHeader={() => ''}>
          <span className="title">母猪胎龄结构</span>
          <div style={{ display: dataReady ? 'block' : 'none' }}>
            <canvas height="260"
                id="myChart1"
                width={clientWidth}
            />
          </div>
          {!dataReady && <EmptyReport height={280}
              width={clientWidth}
                         />}
        </List>

        <List renderHeader={() => ''}>
          <span className="title">实际猪群</span>
          <div style={{ display: dataReady ? 'block' : 'none' }}>
            <canvas height="360"
                id="myChart2"
                width={clientWidth}
            />
          </div>
          {!dataReady && <EmptyReport height={280}
              width={clientWidth}
                         />}
        </List>

        <List renderHeader={() => ''}>
          <span className="title">最佳猪群</span>
          <div style={{ display: dataReady ? 'block' : 'none' }}>
            <canvas height="300"
                id="myChart3"
                width={clientWidth}
            />
          </div>
          {!dataReady && <EmptyReport height={280}
              width={clientWidth}
                         />}
        </List>

        <Modal
            animationType="slide-up"
            closable
            maskClosable={false}
            onClose={() => {
              this.setState({
                modalShow: false
              })
            }}
            // title={'母猪详情'}
            popup
            visible={this.state.modalShow}
        >
          <div className="am-modal-title" style={{height: '40px',lineHeight: '40px'}}>母猪详情</div>

          {this.modal.data.length > 0
            ? <Table
                columns={this.modal.columns}
                data={this.modal.data}
              />
            : <EmptyReport height={280}
                width={clientWidth}
              />}

        </Modal>
      </React.Fragment>
    )
  }
}

export default ParityIndex
